import { number } from "../../assets/mecom/js/format.mjs";
import { clockTime } from "./day-model.mjs";
import { timeDuration } from "./duration-model.mjs";

export const states = { al_lavoro: "Al lavoro", fermo: "Senza attività aperta", fuori: "Assente", assente: "Assente", pausa: "Pausa pranzo", non_valutabile: "Non valutabile" };
export function personStatus(person) {
    if (person.stato === "fuori") {
        if (person.ingresso_aperto) return `Entrato alle ${clockTime(person.ingresso_aperto)}`;
        if (person.ultima_uscita) return `Uscito alle ${clockTime(person.ultima_uscita)}`;
    }
    return states[person.stato] || "Non valutabile";
}
export function idleTime(person, updated) {
    if (!person?.fermo_da || !updated) return "—";
    const minutes = (Date.parse(updated) - Date.parse(person.fermo_da)) / 60000;
    return Number.isFinite(minutes) ? timeDuration(Math.max(0, minutes), true) : "—";
}
export function summary(data) {
    if (!data) return "Team da verificare";
    return `${teamCount(data)} al lavoro`;
}
export function teamCount(data) {
    return data ? `${number(data.al_lavoro, 0)}/${number(data.disponibili, 0)}` : "…";
}
export function validTeam(data) {
    return data && typeof data.applicable === "boolean" && Array.isArray(data.persone) &&
        [data.al_lavoro, data.disponibili, data.non_valutabili].every(Number.isInteger) &&
        Number.isFinite(Date.parse(data.aggiornato_il));
}
